const monthPattern = /^(\d{4})-(0[1-9]|1[0-2])$/;

/** The month an address names, as 2026-10, which the month's email links to. It imports nothing: the route reads it
 * before its page is loaded. */
export function validateBilanSearch(search: Record<string, unknown>): { bilan?: string } {
  const bilan = search["bilan"];
  return typeof bilan === "string" && monthPattern.test(bilan) ? { bilan } : {};
}

/** The year and the month's number of a month as 2026-10. */
export function monthParts(month: string): { year: string; number: number } {
  const [, year = "", number = "1"] = monthPattern.exec(month) ?? [];
  return { year, number: Number(number) };
}
